
import * as KeenSlider from 'keen-slider/keen-slider.es';
export default KeenSlider.default;
